import 'bootstrap';
import React from 'react';
import getDoc from '../../qdoc';

class QlikDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.getList = getDoc.then(doc => {
      return doc.createSessionObject({
        qInfo: {
          qType: "visualization"
        },
        qListObjectDef: { 
          qStateName: this.props.qStateName,
          qDef: {  
            qFieldDefs: [this.props.field],
            qSortCriterias: [{
              qExpression:{qv:this.props.sort},
              qSortByExpression: -1,
              qSortByAscii: 1
            }] 
          },
          qShowAlternatives: true,
          qAutoSortByState: {qDisplayNumberOfRows: 1}
        }
      });
    });

    this.state = {
      name: this.props.name,
      data: [],
      layout: [],
      size: 0,
      offset: 0,
      stateCounts:{},
      totalStateCounts: null
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    this.update();
    this.getList.then(list => {
      list.on('changed', () => {
        this.update();
      });
    });
    
    $(this.refs['dropdown']).on({
      'show.bs.dropdown': () => { this.beginSelections(); },
      'hide.bs.dropdown': () => { this.endSelections(); $(this.refs['search']).val(''); $(this.refs['scrollable']).scrollTop(0); }
    });
  }
  componentWillUnmount() {
    
  }

  update() {
    this.getListObjectData();
    this.getLayout();
  }

  getListObjectData() {
    this.getList.then(list => {
      list.getListObjectData("/qListObjectDef", [{
        qTop: this.state.offset, 
        qLeft: 0, 
        qHeight: 10, 
        qWidth: 1
      }]).then(listObjectData => {
        this.setState({data: listObjectData[0].qMatrix});
      });
    });
  }

  getLayout() {
    this.getList.then(list => {
      list.getLayout().then(layout => {
        let stateCounts = layout.qListObject.qDimensionInfo.qStateCounts;
        let totalStateCounts = 0;
        for (let state in stateCounts) {
          totalStateCounts += stateCounts[state];
        }
        this.setState({size: layout.qListObject.qSize.qcy, stateCounts: layout.qListObject.qDimensionInfo.qStateCounts, totalStateCounts: totalStateCounts });
      })
    });
  }

  searchListObjectFor(string) {
    this.getList.then(list => {
      list.searchListObjectFor("/qListObjectDef", string);
    });
  }

  acceptListObjectSearch() {
    this.getList.then(list => {
      list.acceptListObjectSearch("/qListObjectDef", true);
    });
  }

  beginSelections() {
    this.getList.then(list => {
      list.beginSelections(['/qListObjectDef']);
    });
  }

  endSelections() {
    this.getList.then(list => {
      list.endSelections(true);
    });
  }

  selectRow(elnum) {
    this.getList.then(list => {
      list.selectListObjectValues('/qListObjectDef', [elnum], true);
    });
  }

  render() {
    return (
      <div className="dropdown" ref="dropdown">
        <button className="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{borderBottom:'0px'}}>
          {this.props.name} 
        </button>
        <div className="state-counts" style={{position: 'relative', backgroundColor:'#c9c9c9', height:'3px'}}>
          <div style={{position: 'absolute', width: `${(this.state.stateCounts.qOption + this.state.stateCounts.qSelected)*100 / this.state.totalStateCounts}%`, height:'100%' , background: '#C7AC5F',transition: 'width .6s ease'}}/>
        </div>
        {/* <div className="subinfo"> {this.state.stateCounts.qOption + this.state.stateCounts.qSelected} of {this.state.size} </div> */}
        
        <div className="dropdown-menu" style={{width: this.props.menuWidth}}>
          <input type="text" style={{height: `calc(${this.props.rowHeight} * 1.5`}} placeholder="Search..." ref="search" onChange={this.handleChange} onKeyPress={this.handleKeyPress}/>
          <form>
            <div className="scrollable" style={{maxHeight: `calc(${this.props.rowHeight} * 10)`, overflow: 'auto'}} onScroll={this.handleScroll} ref="scrollable">
              <ul className="list-group" style={{marginBottom: 0}} ref="list">
                {this.state.data.map((row) => {
                  return <li key={row[0].qElemNumber} className={`list-group-item ${row[0].qState} e${row[0].qElemNumber}`} style={{height: this.props.rowHeight, marginBottom: '0'}} data-elem-number={row[0].qElemNumber} onClick={this.handleClick}>
                    <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', pointerEvents: 'none'}}>{row[0].qText}</div>
                  </li>; 
                })}
              </ul>
              <div className="scroll-allowance" style={{height: `calc(${this.props.rowHeight} * (${this.state.size} - 10))`}}></div>
            </div>
          </form>
        </div>
      </div>
    )
  }
  handleChange(event) {
    $(this.refs['scrollable']).scrollTop(0);
    this.setState({offset: 0});
    this.searchListObjectFor($(event.target).val());
  }
  handleScroll(event) {
    $(this.refs['list']).css('transform', `translateY(${$(this.refs['scrollable']).scrollTop()}px)`);
    this.setState({offset: Math.floor($(event.target).scrollTop() / $(this.refs['list']).find('li').outerHeight())});
    this.getListObjectData();
  }
  handleClick(event) {
    this.selectRow($(event.target).data('elem-number'));
  }
  handleKeyPress(event) {
    if(event.charCode === 13) {
      this.acceptListObjectSearch();
      $(this.refs['search']).val('');
    }
  }
}
QlikDropdown.defaultProps = {rowHeight: '30px', menuWidth: 'auto'};

export default QlikDropdown;


// WEBPACK FOOTER //
// ./components/Dropdown/index.js